export const selectDepartments = state => state.department;
